import { render, staticRenderFns } from "./CtaModalStart.vue?vue&type=template&id=a971a720&"
import script from "./CtaModalStart.vue?vue&type=script&lang=js&"
export * from "./CtaModalStart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports